<template>
  <div class="media-interception">
    <div class="music-info">
      <div class="music-info-switch">
        使用背景音乐
        <a-switch :checked="setupMusic" @change="toggleSetupMusic" />
      </div>
      <div class="border-bottom"></div>
      <InfoTitle title="音乐设置" button-text="更换音乐" :fn="showMusicMenu" />
      <div class="music-info-card">
        <div class="logo-wrap">
          <span class="icon iconfont pay">&#xe6ee;</span>
        </div>
        <div class="name-duration-button">
          <div class="name" :title="currentMusicName">
            {{ currentMusicName }}
          </div>
          <div class="duration-button">
            <div class="duration">总时长：{{ endTime }}</div>
          </div>
        </div>
      </div>
      <LabelSlider
        label="音量"
        :useModel="true"
        :max="100"
        :min="0"
        :step="1"
        :value="volume"
        @change="handleVolume"
        percentage
      />
      <label-switch label="音量淡入" v-model="musicFade.fadeIn" />
      <label-input
        label="时长 (s)"
        :disabled="!musicFade.fadeIn"
        v-model="musicFade.fadeInDuration"
        :time="true"
        :min="500"
        :max="6e3"
      />
      <label-switch label="音量淡出" v-model="musicFade.fadeOut" />
      <label-input
        label="时长 (s)"
        :disabled="!musicFade.fadeOut"
        v-model="musicFade.fadeOutDuration"
        :time="true"
        :min="500"
        :max="6e3"
      />
      <label-switch label="循环" v-model="musicFade.loop" />
      <label-input
        label="延迟播放 (s)"
        v-model="musicFade.delay"
        :time="true"
        :min="0"
        :max="totalDuration"
      />
      <div class="border-bottom"></div>
      <InfoTitle title="音频截取" />
    </div>
    <audio-cropper
      :src="currentMusicUrl"
      :duration.sync="duration"
      @change="handleStartEnd"
      @reset="reset"
      :value="startEnd"
      :customReset="true"
      ref="cropper"
      @play="handleCropperPlay"
      @pause="handleCropperPause"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import AudioCropper from '../music/AudioCropper';
import { timeFormat } from '../../utils/util';
import LabelSlider from "./LabelSlider";
import InfoTitle from "./InfoTitle";
import LabelSwitch from './LabelSwitch';
import LabelInput from './LabelInput';

export default {
  name: "MediaInterception",
  components: { AudioCropper, LabelSlider, InfoTitle, LabelSwitch, LabelInput },
  data: function () {
    return {
      duration: 100,
      isPlaying: false
    }
  },
  methods: {
    ...mapMutations(['handleMusicStartEnd', 'handleVideoStartEnd', 'handleMusicInfoIsPlaying', 'handleMusicVolume', 'handleSetupMusic', 'handleMyVideoMusic']),
    async setAudioCropLock(f) {
      if (!this.audioCropLock) {
        this.audioCropLock = true;
        await f();
        requestAnimationFrame(() => {
          this.audioCropLock = false;
        });
      }
    },
    handleStartEnd: function (e) {
      this.setAudioCropLock(() => {
        this.handleMusicStartEnd([e.start, e.end]);
      });
    },
    handleVolume: function (value) {
      this.handleMusicVolume( value / 100);
    },
    reset(e) {
      this.handleStartEnd({
        ...e,
        end: e.total
      });
    },
    showMusicMenu: function () {
      const cropper = this.$refs.cropper;

      if (cropper.playing) {
        cropper.togglePlay();
      }
      this.$store.commit('handleCurrentMenu', 'MusicMenu');
      this.$store.commit('handleAudioEdit', 'background');
    },
    toggleSetupMusic: function (setup) {
      if (!this.myVideoMusic.id && setup) {
        // 初次设置应设置myVideoMusic
        this.handleMyVideoMusic(this.$store.state.currentMusic)
      } else {
        this.handleSetupMusic(setup)
      }
    },
    handleCropperPlay() {
      this.isPlaying = true;
    },
    handleCropperPause() {
      this.isPlaying = false;
    }
  },
  computed: {
    ...mapGetters(['totalDuration']),
    ...mapState(['myVideoMusic', 'musicMenuIsPlaying', 'myMusicVolume', 'musicVolume', 'setupMusic', 'musicFade']),
    currentMusicUrl() {
      return this.$store.state.currentMusic.material_url
    },
    currentMusicName() {
      return this.$store.state.currentMusic.material
    },
    startEnd() {
      const { musicStartEnd } = this.$store.state;
      return musicStartEnd;
    },
    volume() {
      const musicVolume = (this.musicVolume || this.musicVolume === 0) ? this.musicVolume : 1;
      return Math.round(musicVolume * 100);
    },
    endTime() {
      return timeFormat(this.duration, 2);
    }
  },

  watch: {
    musicMenuIsPlaying(val) {
      if (val) {
        const cropper = this.$refs.cropper;
        if (cropper.playing) {
          cropper.togglePlay();
        }
      }
    },
    isPlaying(val) {
      this.handleMusicInfoIsPlaying(val);
    }
  }
}
</script>

<style scoped>
.video-crop {
  font-size: 12px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.video-crop-preview {
  width: 207px;
  height: 115px;
  object-fit: cover;
  border: 6px solid #ffffff;
  margin-top: 4px;
}

.time {
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 6px;
}

.music-info-card {
  display: flex;
  padding: 6px 0;
  box-sizing: border-box;
  margin-top: 10px;
}

.music-info .name-duration-button {
  margin-left: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.music-info .name {
  width: 137px;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.music-info .logo-wrap {
  width: 43px;
  height: 43px;
  background: rgba(138, 166, 255, 1);
  border-radius: 30px;
  text-align: center;
  line-height: 43px;
  flex-shrink: 0;
}

.pay {
  color: #ffffff;
  font-size: 24px;
}

.music-info .duration-button {
  display: flex;
  align-items: center;
  width: 137px;
  justify-content: space-between;
  margin-top: 3px;
}

.music-info .duration {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
}

.music-info-switch {
  font-size: 12px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  margin: 15px 0 5px;
  align-items: center;
}

.music-info .border-bottom {
  padding-bottom: 10px;
  border-bottom: 1px solid #d8d8d8;
  width: 100%;
}

.music-info .info-title {
  margin: 10px 0 5px;
}
</style>
